import React from 'react';
import { TextEscape } from '../components/text-escape/TextEscape';
import '../components/text-escape/TextEscape.css';

export const TextEscapePage: React.FC = () => {
  return (
    <div className="page-container">
      <TextEscape />
    </div>
  );
};
